import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-3" }
const _hoisted_2 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_3 = { class: "bg-gray-100 rounded-xl p-2.5 shrink-0" }
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "text-sm font-bold text-gray-900 truncate" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = {
  key: 0,
  class: "h-1.5 w-1.5 rounded-full bg-green-500",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 1,
  class: "shrink-0 text-xs font-semibold text-gray-400 bg-gray-100 rounded-full px-2 py-0.5"
}
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-between gap-3 mt-4"
}
const _hoisted_10 = { class: "flex gap-10 mt-5" }
const _hoisted_11 = { class: "h-14 mt-4" }
const _hoisted_12 = { class: "border-t border-gray-100 mt-4 pt-3 text-sm text-gray-400" }
const _hoisted_13 = { class: "border-t border-gray-100 mt-4 pt-3" }
const _hoisted_14 = { class: "text-sm text-gray-500 mt-4 mb-5" }
const _hoisted_15 = {
  key: 1,
  class: "mt-auto inline-flex items-center gap-2 text-sm font-medium text-gray-400"
}

import { computed } from 'vue'

import BarChart from '@/components/BarChart.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { iconFor } from '@/view/ai/agentIcons'
import { cardState } from '@/view/ai/agentsDashboardData'


export default {
  __name: 'AgentPerformanceCard',
  props: {
  card: { type: Object, required: true },
  metrics: { type: Object, default: null }
},
  emits: ['go-live'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

// A live agent hides the testing state: the card is Active whenever any agent is live.
const isTesting = computed(() => Boolean(props.metrics?.testMode && !props.metrics?.isActive))

const BADGES = {
  active: { label: 'Active', classes: 'bg-green-100 text-green-700', dot: true },
  testing: { label: 'Testing', classes: 'bg-indigo-100 text-indigo-700', dot: false },
  inactive: { label: 'Inactive', classes: 'bg-gray-100 text-gray-600', dot: false }
}
const badge = computed(() => {
  if (isTesting.value) return BADGES.testing
  return props.metrics?.isActive ? BADGES.active : BADGES.inactive
})

const state = computed(() => cardState(props.card, props.metrics))

const isEmpty = computed(() => state.value === 'active-empty')

const formattedSales = computed(() => `$${((props.metrics?.salesDrivenCents || 0) / 100).toFixed(2)}`)

const chartData = computed(() => {
  const counts = props.metrics?.dailyCounts || []
  return {
    labels: counts.map((_, i) => `${i}`),
    datasets: [
      { data: counts, backgroundColor: '#0f172a', borderRadius: 4, categoryPercentage: 0.6, barPercentage: 0.85 }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false }, title: { display: false }, tooltip: { enabled: false } },
  scales: {
    x: { display: false, grid: { display: false } },
    y: { display: false, grid: { display: false }, beginAtZero: true }
  }
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-2xl p-5 flex flex-col border border-gray-200", __props.metrics ? 'bg-white' : 'bg-gray-50'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(iconFor)(__props.card.iconKey)), { class: "h-5 w-5 text-gray-700" }))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.card.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.card.category), 1)
        ])
      ]),
      (__props.metrics)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["shrink-0 inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2 py-0.5", badge.value.classes])
          }, [
            (badge.value.dot)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(badge.value.label), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, " Not set up "))
    ]),
    (__props.metrics)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (isTesting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Talks only to your test number.", -1)),
                _createVNode(NeueButton, {
                  type: "secondary",
                  "data-go-live": "",
                  onClick: _cache[0] || (_cache[0] = $event => (emit('go-live', __props.metrics.agentId)))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Go live", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Sales driven", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["text-lg font-bold", isEmpty.value ? 'text-gray-400' : 'text-gray-900'])
              }, _toDisplayString(formattedSales.value), 3)
            ]),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Conversations", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["text-lg font-bold", isEmpty.value ? 'text-gray-400' : 'text-gray-900'])
              }, _toDisplayString(__props.metrics.conversationsCount), 3)
            ])
          ]),
          (!isEmpty.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(BarChart, {
                    "chart-data": chartData.value,
                    "chart-options": chartOptions
                  }, null, 8, ["chart-data"])
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-2" }, "Conversations · last 7 days", -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(__props.card.emptyHint), 1),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-3" }, "No conversations yet · last 7 days", -1))
              ], 64)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: `/ai/agents/${__props.metrics.agentId}`,
              class: "text-sm font-medium text-gray-700 hover:text-gray-900 flex items-center justify-between"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", null, "View activity", -1),
                _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(__props.card.description), 1),
          (state.value === 'setup')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: __props.card.route,
                class: "mt-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(NeueButton, { type: "primary" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Setup →", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(iconFor)('clock')), { class: "h-4 w-4" })),
                _cache[9] || (_cache[9] = _createTextVNode(" Coming soon ", -1))
              ]))
        ], 64))
  ], 2))
}
}

}